import React from 'react';

import { Greet } from '~/types/models';
import DownloadAppBanner from '../Components/DownloadAppBanner';
import useUserStats from '~/react-hooks/use-user-stats';
import GreetRecordContainer from './GreetRecordContainer';
import ProTipRollup from '~/App/Components/Navigation/ProTipRollup';
import CustomerContext from '~/App/Components/RecorderDrawer/Components/CustomerContext';
import HeaderActions from '../Components/Greet/HeaderActions';

export type GreetBodyContainer = {
  greet: Greet;
};

export default function GreetBodyContainer({ greet }: GreetBodyContainer) {
  const { hasInstalledApp, hasSentRollUp } = useUserStats();

  return (
    <div className='flex flex-col h-full'>
      <HeaderActions
        className='flex md:hidden mb-4'
        greet={greet}
        showWorkspace
      />
      <div className='flex flex-col md:flex-row gap-x-7 h-full grow md:overflow-auto'>
        <div className='flex flex-col justify-between w-full md:w-[50%] md:max-w-[460px]'>
          <div>
            <GreetRecordContainer greet={greet} />
            {!hasSentRollUp && <ProTipRollup className='mt-5' />}
          </div>
          {!hasInstalledApp && <DownloadAppBanner className='max-w-3xl mt-4' />}
        </div>
        <div className='flex flex-col gap-y-5 w-full md:w-[58%] md:max-w-[600px]'>
          <HeaderActions
            className='hidden md:!flex'
            greet={greet}
            showWorkspace
          />
          <div className='flex grow mt-4 md:mt-0'>
            <CustomerContext greet={greet} />
          </div>
        </div>
      </div>
    </div>
  );
}
